import LogCannon from '@ace-clublabs/log-cannon';
import axios from 'axios';
import CookieHelper from '../../utils/cookieHelper';
import { AuthorizeSession, AuthorizeSessionRequest } from '../contracts';
import { createAxiosConfig } from '../mockHelper';

export const AuthorizeSessionApi =
  (endpoint: string): AuthorizeSession =>
  async (request: AuthorizeSessionRequest) => {
    try {
      LogCannon.blast('AuthorizeSessionApi start', {
        endpoint,
      });
      const scenario = CookieHelper.getCookie('scenario');
      const config = createAxiosConfig(scenario, endpoint);
      const response = await axios.post(endpoint, request, config);
      LogCannon.blast('AuthorizeSessionApi success');
      return Promise.resolve(response.data);
    } catch (error: any) {
      const data = error.response?.data;
      LogCannon.error('AuthorizeSessionApi error', { error: data?.message || error });
      if (error.response) {
        return Promise.reject({
          message: data?.message,
          requestId: data?.requestId,
        });
      } else {
        return Promise.reject({
          message: error,
        });
      }
    }
  };
